import { useLanguageContext } from 'context/LanguageProvider';
import { useEffect, useState } from 'react';
import { DEFAULT_LANGUAGE, isValidLocaleValue } from 'utils/languageUtils';

const useLocale = () => {
  const { language } = useLanguageContext();
  const [locale, setLocale] = useState(isValidLocaleValue(language) ? language : DEFAULT_LANGUAGE);
  useEffect(() => {
    setLocale(isValidLocaleValue(language) ? language : DEFAULT_LANGUAGE);
  }, [language]);
  return locale;
};
export default useLocale;
